import React from "react";
import Button from "../Button.js";
import Timer from "../PageQuiz/Timer.js";

class QuestionMultiplayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.props.time,
      letterToIndex: new Map([
        ["a", 0],
        ["b", 1],
        ["c", 2],
        ["d", 3],
        ["A", 0],
        ["B", 1],
        ["C", 2],
        ["D", 3],
      ]),
    };
  }

  componentDidMount() {
    console.log("componentDidMount");
  }

  componentDidUpdate(prevProps) {
    if (this.props.question !== prevProps.question) {
      this.setState({ time: this.props.time });
    }
  }

  handleClickAnswer(selectAnswer) {
    console.log(this.state.letterToIndex);
    console.log(selectAnswer);
    if (
      selectAnswer === this.props.a[this.state.letterToIndex.get(this.props.ga)]
    ) {
      console.log("good");
      this.props.onGood();
    } else {
      console.log("bad");
      this.props.onBad();
    }
  }

  reportQuestion() {
    fetch(process.env.REACT_APP_API_URL + "/report_question", {
      method: "PUT",
      body: JSON.stringify({
        question_title: this.state.question,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
      });
  }

  render() {
    return (
      <div>
        <Timer
          onEnd={() => {
            this.props.onEnd();
          }}
          isFinished={this.props.isFinished}
          isPaused={this.props.isPaused} // Changed isPause to isPaused to match the prop
          time={this.state.time}
          action={() => this.setState({ time: this.state.time - 1 })}
        />
        <h2 className="my-3">{this.props.question}</h2>
        <div className="d-grid gap-2">
          <button
            className="btn btn-primary"
            disabled={this.props.isPaused} // Changed isPause to isPaused to match the prop
            value={this.props.a[0]}
            onClick={() => this.handleClickAnswer(this.props.a[0])}
          >
            {this.props.a[0]}
          </button>
          <button
            className="btn btn-primary"
            disabled={this.props.isPaused}
            value={this.props.a[1]}
            onClick={() => this.handleClickAnswer(this.props.a[1])}
          >
            {this.props.a[1]}
          </button>
          <button
            className="btn btn-primary"
            disabled={this.props.isPaused}
            value={this.props.a[2]}
            onClick={() => this.handleClickAnswer(this.props.a[2])}
          >
            {this.props.a[2]}
          </button>
          <button
            className="btn btn-primary"
            disabled={this.props.isPaused}
            value={this.props.a[3]}
            onClick={() => this.handleClickAnswer(this.props.a[3])}
          >
            {this.props.a[3]}
          </button>
        </div>
        <div className="d-grid gap-2 mt-4">
          <button
            className="btn btn-danger"
            onClick={() => this.reportQuestion()}
          >
            Report error
          </button>
        </div>
      </div>
    );
    
  }
}

export default QuestionMultiplayer;
